/**
 * 应用配置文件
 * 统一管理项目中的配置信息
 */

// API 基础路径配置
// 本地开发环境
// export const BASE_URL = 'http://localhost:9999/jier-admin-service/';
export const BASE_URL = 'https://admin.jierapp.com/jier-admin-service/';

// WebSocket 基础地址
// 本地开发环境
// export const WS_BASE_URL = 'ws://localhost:9090/jierApp/ws';
export const WS_BASE_URL = 'wss://app.jierapp.com/jierApp/ws/customer';

// 其他配置可以在这里添加
export default {
  BASE_URL,
  WS_BASE_URL
};
